import React from "react";
import { Event, PageConfigurationContextConsumer } from "./index";
import "./styles/latest-event.css";
import moment from "moment";
import LocationIcon from "./LocationIcon";
import Color from "color";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";
import LatestStar from "./vectors/LatestStar";
import EventCoverPhoto from "./EventCoverPhoto";

const LatestEvent = ({
  event,
  showGetNotifiedPopup,
  eventPath,
  editMode,
  showUpdateEventCoverPopup
}: {
  event: Event;
  showGetNotifiedPopup: Function;
  eventPath: Function;
  editMode: boolean;
  showUpdateEventCoverPopup: Function;
}) => {
  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <a
            className="event-card container"
            href={eventPath(event)}
            onClick={(e: any) => {
              localStorage.setItem("isNavigatedFromOrgGallery", "true");
              if (!event.coverPhoto && !editMode) {
                e.preventDefault();
                showGetNotifiedPopup(event);
              }
            }}
          >
            <div className="latest-ev-container">
              <div className="latest-ev-img-div">
                <EventCoverPhoto
                  event={event}
                  editMode={editMode}
                  pageConfiguration={pageConfiguration}
                  showUpdateEventCoverPopup={showUpdateEventCoverPopup}
                  className="latest-ev-img-inner-div"
                ></EventCoverPhoto>
                <div className="latest-ev-date-badge">
                  <p className="latest-ev-date-p1">{event.day}</p>
                  <p className="latest-ev-date-p2">{event.month}</p>
                  <p className="latest-ev-date-p3">{event.year}</p>
                </div>
              </div>
              <div
                className="latest-ev-info-div"
                style={{
                  background: `linear-gradient(258.77deg, ${Color(
                    pageConfiguration.primaryColor
                  )
                    .darken(0.2)
                    .hex()} 23.79%, ${pageConfiguration.primaryColor} 72.9%)`
                }}
              >
                <p
                  className={`latest-ev-info-head ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.primaryColor
                  )}`}
                >
                  {event.name}
                </p>
                <p
                  className={`latest-ev-info-p ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.primaryColor
                  )}`}
                ></p>
                <div className="latest-ev-location-div">
                  <div className="location-pin-img">
                    <LocationIcon
                      color={ContrastForegroundUtility.fgColor(
                        pageConfiguration.primaryColor
                      )}
                    />
                  </div>
                  <div>
                    <p
                      className={`latest-ev-location-p1 ${ContrastForegroundUtility.fgClass(
                        pageConfiguration.primaryColor
                      )}`}
                    >
                      {event.location}
                    </p>
                    <p
                      className={`latest-ev-location-p2 ${ContrastForegroundUtility.fgClass(
                        pageConfiguration.primaryColor
                      )}`}
                    >
                      {event.country}
                    </p>
                  </div>
                </div>
                <div
                  className="latest-ev-tag-div"
                  style={{ background: pageConfiguration.secondaryColor }}
                >
                  <LatestStar
                    color={ContrastForegroundUtility.fgColor(
                      pageConfiguration.secondaryColor
                    )}
                  />
                  <span
                    className={`latest-ev-tag-span ${ContrastForegroundUtility.fgClass(
                      pageConfiguration.secondaryColor
                    )}`}
                  >
                    Latest
                  </span>
                </div>
              </div>
            </div>
          </a>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default LatestEvent;
